/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const formDataSchema = z.object({
	id: z.string(),
	organisationId: z.string(),
	organisationName: z.string(),
	poolConsentUrl: z.string(),
	organisationRetentionMonths: z.number(),
	campaignId: z.string(),
	privacyUrl: z.string().nullable(),
	welcomeScreen: z.object({
		id: z.string(),
		title: z.string(),
		campaignId: z.string(),
		subtitle: z.string().nullable(),
		description: z.string().nullable(),
		descriptionHtml: z.string().nullable(),
		subtext: z.string().nullable(),
		imageId: z.string().nullable(),
		image: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		imagesHistory: z.array(
			z.object({
				historyUpdatedAt: z.iso.datetime(),
				id: z.string(),
				name: z.string(),
				fileName: z.string(),
				category: z.union([z.literal('image'), z.literal('file')]),
				mimeType: z.string().nullable(),
				size: z.number(),
				humanReadableSize: z.string(),
				url: z.string(),
				collectionName: z.union([
					z.literal('ad-asset'),
					z.literal('baked-story'),
					z.literal('baked-feed'),
					z.literal('story'),
					z.literal('feed'),
					z.literal('landing-page'),
					z.literal('logo'),
					z.literal('generated'),
					z.literal('uploaded'),
					z.literal('imported'),
					z.literal('candidate-files'),
					z.literal('custom-font'),
					z.literal('design'),
					z.literal('whatsapp-profile'),
				]),
				width: z.number(),
				height: z.number(),
				isPlaceholder: z.boolean(),
				isGenerating: z.boolean(),
				createdAt: z.iso.datetime(),
				isGenerated: z.boolean().default(false),
				startedGenerationAt: z.iso.datetime().nullable(),
				finishedGenerationAt: z.iso.datetime().nullable(),
				meta: z.record(z.string(), z.unknown()).nullable(),
			}),
		),
		logo: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		videoUrl: z.string().nullable(),
		updatedAt: z.iso.datetime(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	language: z.string(),
	questions: z.array(
		z.object({
			id: z.string().nullable(),
			label: z.string(),
			type: z.union([
				z.literal('select'),
				z.literal('text'),
				z.literal('open_text'),
				z.literal('file'),
				z.literal('datetime'),
			]),
			attribute: z.union([
				z.literal('name'),
				z.literal('email'),
				z.literal('phone'),
				z.literal('contact_consent'),
				z.literal('cv'),
			]).nullable(),
			subtype: z.union([z.literal('name'), z.literal('email'), z.literal('phone'), z.literal('multiple')])
				.nullable(),
			validationRules: z.array(z.string()).nullable(),
			position: z.number(),
			options: z.array(
				z.object({
					id: z.string().uuid(),
					label: z.string(),
					position: z.number(),
					consentType: z.string().nullable(),
					escoSkills: z.array(
						z.object({ conceptUri: z.string(), preferredLabel: z.string(), confirmedByUser: z.boolean() }),
					).nullable(),
					escoMappingReason: z.string().nullable(),
				}),
			).nullable(),
			updatedAt: z.iso.datetime(),
		}),
	),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	branding: z.object({
		id: z.string().nullable(),
		organisationId: z.string().nullable(),
		name: z.string().nullable(),
		website: z.string().nullable(),
		logoId: z.string().nullable(),
		logo: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}).nullable(),
		toneOfVoice: z.string().nullable(),
		visualGuidance: z.string().nullable(),
		cornerRadius: z.string().nullable(),
		background: z.string(),
		foreground: z.string(),
		accentBackground: z.string(),
		accentForeground: z.string(),
		fonts: z.object({ title: z.string().nullable(), body: z.string().nullable() }),
		createdAt: z.iso.datetime().nullable(),
		updatedAt: z.iso.datetime().nullable(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
		generateKeyImage: z.boolean().default(true),
		generationError: z.union([z.literal('website_unreachable'), z.literal('scan_failed')]).nullable(),
	}).nullable(),
	closedAt: z.iso.datetime().nullable(),
	careerSiteSlug: z.string().nullable(),
	isGenerated: z.boolean().default(false),
	startedGenerationAt: z.iso.datetime().nullable(),
	finishedGenerationAt: z.iso.datetime().nullable(),
	meta: z.record(z.string(), z.unknown()).nullable(),
})

export type FormDataSchema = z.infer<typeof formDataSchema>
